export default "__VITE_ASSET__B$WQu5DW__"